"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Switch = _interopRequireDefault(require("../../../components/Switch"));
var _Bubble = _interopRequireDefault(require("../../../components/Bubble"));
var _BubbleSelectBlock = _interopRequireDefault(require("../../../components/BubbleSelectBlock"));
var _NumberInput = _interopRequireDefault(require("../../../components/TextFields/NumberInput"));
var _Text = _interopRequireDefault(require("../../../components/Text"));
var _TextInput = _interopRequireDefault(require("../../../components/TextFields/TextInput"));
var _BlockContent = _interopRequireDefault(require("../../../components/BlockContent"));
var _HeaderDiv = _interopRequireDefault(require("../../../components/HeaderDiv"));
var _theme = require("../../../theme");
var _i18n = _interopRequireDefault(require("../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../localization/tokens"));
var _services = require("../../../services");
var localizationMaps = _interopRequireWildcard(require("../../../localization/maps"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Healthcare = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Healthcare, _Component);
  function Healthcare() {
    var _this;
    (0, _classCallCheck2["default"])(this, Healthcare);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, Healthcare, [].concat(args)), _this.state = {
      data: null
    }, _this._setData = function (data) {
      var defaults = {
        isSelected: data.isSelected || false,
        hasDeductible: data.hasDeductible || false,
        soloDeductibleAmount: data.soloDeductibleAmount || 0,
        duoDeductibleAmount: data.duoDeductibleAmount || 0,
        familyDeductibleAmount: data.familyDeductibleAmount || 0,
        majorHealthCombinedMaximumSelected: data.majorHealthCombinedMaximumSelected || false,
        majorHealthCombinedMaximum: data.majorHealthCombinedMaximum || 0,
        majorHealthReimbursement: typeof data.majorHealthReimbursement === "number" ? data.majorHealthReimbursement : 100,
        privateDutyNursing: typeof data.privateDutyNursing === "number" ? data.privateDutyNursing : 10000,
        hospitalBenefits: 'rc',
        ambulanceServices: 'rc',
        medicalServicesAndSupplies: 'rc',
        medicalEquipment: 'rc',
        hospitalBenefitsType: data.hospitalBenefitsType || 'Private',
        hospitalBenefitsReimbursement: data.hospitalBenefitsReimbursement || 0,
        footOrthotics: data.footOrthotics || 0,
        orthopedicShoes: data.orthopedicShoes || 0,
        prosthetics: typeof data.prosthetics === "number" ? data.prosthetics : 25000,
        hearingAids: data.hearingAids || 0,
        hearingAidsPeriod: typeof data.hearingAidsPeriod === "number" ? data.hearingAidsPeriod : 60,
        dentalAccidentMax: typeof data.dentalAccidentMax === "number" ? data.dentalAccidentMax : 0,
        dentalAccidentReimbursement: data.dentalAccidentReimbursement || 100,
        cataractSurgeryEyewear: typeof data.cataractSurgeryEyewear === "number" ? data.cataractSurgeryEyewear : 0,
        cataractSurgeryEyewearPeriod: typeof data.cataractSurgeryEyewearPeriod === "number" ? data.cataractSurgeryEyewearPeriod : 0,
        cardiacRehabilitation: typeof data.cardiacRehabilitation === "number" ? data.cardiacRehabilitation : 500,
        apneaMachine: typeof data.apneaMachine === "number" ? data.apneaMachine : 2000,
        apneaMachineSupplies: 'rc',
        apneaMask: 'rc',
        artificialEyeLimbRepairReplacement: typeof data.artificialEyeLimbRepairReplacement === "number" ? data.artificialEyeLimbRepairReplacement : 1000,
        bloodPressureMonitor: typeof data.bloodPressureMonitor === "number" ? data.bloodPressureMonitor : 100,
        bracesWithRigidSupports: 'rc',
        compressionStockings: typeof data.compressionStockings === "number" ? data.compressionStockings : 100,
        crutches: 'rc',
        glucoseMonitoringEquipmentSupplies: typeof data.glucoseMonitoringEquipmentSupplies === "number" ? data.glucoseMonitoringEquipmentSupplies : 4000,
        insulinPump: typeof data.insulinPump === "number" ? data.insulinPump : 5000,
        insulinPumpSupplies: typeof data.insulinPumpSupplies === "number" ? data.insulinPumpSupplies : 3500,
        ippBreathingMachine: 'rc',
        ostomySupplies: 'rc',
        surgicalBra: 'rc',
        tensMachine: typeof data.tensMachine === "number" ? data.tensMachine : 3500,
        viscosupplementation: typeof data.viscosupplementation === "number" ? data.viscosupplementation : 600,
        wheelchairManual: typeof data.wheelchairManual === "number" ? data.wheelchairManual : 1000,
        wheelchairElectric: typeof data.wheelchairElectric === "number" ? data.wheelchairElectric : 3000,
        wigs: typeof data.wigs === "number" ? data.wigs : 500,
        includeConvalescentHospital: data.includeConvalescentHospital || false,
        convalescentHospitalReimbursement: data.convalescentHospitalReimbursement || 0,
        convalescentHospitalDailyMax: data.convalescentHospitalDailyMax || 20,
        convalescentHospitalMaxDays: data.convalescentHospitalMaxDays || 90,
        includeDiagnosticServices: data.includeDiagnosticServices || false,
        diagnosticServicesMax: typeof data.diagnosticServicesMax === "number" ? data.diagnosticServicesMax : 0,
        diagnosticServicesReimbursement: typeof data.diagnosticServicesReimbursement === "number" ? data.diagnosticServicesReimbursement : 0,
        includeMedicalReferral: data.includeMedicalReferral || false,
        medicalReferralMax: typeof data.medicalReferralMax === "number" ? data.medicalReferralMax : 0,
        medicalReferralReimbursement: typeof data.medicalReferralReimbursement === "number" ? data.medicalReferralReimbursement : 100,
        paramedicalPerPractitionerSelected: data.paramedicalPerPractitionerSelected === undefined ? true : data.paramedicalPerPractitionerSelected,
        paramedicalApplyAmountToAllSelected: data.paramedicalApplyAmountToAllSelected || false,
        paramedicalSetPerPractitionerSelected: data.paramedicalSetPerPractitionerSelected || false,
        paramedicalCombinedMaximumSelected: data.paramedicalCombinedMaximumSelected || false,
        paramedicalPerPractitionerToCombinedMaximumSelected: data.paramedicalPerPractitionerToCombinedMaximumSelected || false,
        paramedicalCombinedMaximum: data.paramedicalCombinedMaximum || 0,
        paramedicalCombineByGroupSelected: data.paramedicalCombineByGroupSelected || false,
        paramedicalMaximum: data.paramedicalMaximum || 0,
        paramedicalReimbursement: typeof data.paramedicalReimbursement === "number" ? data.paramedicalReimbursement : 80,
        paramedicalGroupMentalWellnessSelected: data.paramedicalGroupMentalWellnessSelected || false,
        mentalWellnessReimbursement: typeof data.mentalWellnessReimbursement === "number" ? data.mentalWellnessReimbursement : 80,
        mentalWellnessMaximum: data.mentalWellnessMaximum || 0,
        chiropractorMaximum: data.chiropractorMaximum || 0,
        massageMaximum: data.massageMaximum || 0,
        naturopathMaximum: data.naturopathMaximum || 0,
        osteopathMaximum: data.osteopathMaximum || 0,
        occupationalTherapistMaximum: data.occupationalTherapistMaximum || 0,
        physiotherapyMaximum: data.physiotherapyMaximum || 0,
        podiatristMaximum: data.podiatristMaximum || 0,
        psychologistMaximum: data.psychologistMaximum || 0,
        speechTherapyMaximum: data.speechTherapyMaximum || 0,
        socialWorkerMaximum: data.socialWorkerMaximum || 0,
        acupuncturistMaximum: data.acupuncturistMaximum || 0,
        chiropodistMaximum: data.chiropodistMaximum || 0,
        audiologistMaximum: data.audiologistMaximum || 0,
        registeredDieticianMaximum: data.registeredDieticianMaximum || 0,
        includeEyeExams: data.includeEyeExams || false,
        eyeExamReimbursement: typeof data.eyeExamReimbursement === "number" ? data.eyeExamReimbursement : 80,
        eyeExamChildMax: data.eyeExamChildMax || 0,
        eyeExamAdultMax: data.eyeExamAdultMax || 0,
        eyeExamRolloverPeriodChild: 12,
        eyeExamRolloverPeriodAdult: 24,
        includeEyeGlassesAndContacts: data.includeEyeGlassesAndContacts || false,
        eyeGlassesAndContactsReimbursement: data.eyeGlassesAndContactsReimbursement || 0,
        eyeGlassesAndContactsChildMax: data.eyeGlassesAndContactsChildMax || 0,
        eyeGlassesAndContactsAdultMax: data.eyeGlassesAndContactsAdultMax || 0,
        eyeGlassesAndContactsPeriodChild: 12,
        eyeGlassesAndContactsPeriodAdult: 24,
        includeRequiredSafetyEyeWear: data.includeRequiredSafetyEyeWear || false,
        requiredSafetyEyeWearReimbursement: data.requiredSafetyEyeWearReimbursement || 0,
        requiredSafetyEyeWearChildMax: data.requiredSafetyEyeWearChildMax || 0,
        requiredSafetyEyeWearAdultMax: data.requiredSafetyEyeWearAdultMax || 0,
        requiredSafetyEyeWearPeriodChild: 12,
        requiredSafetyEyeWearPeriodAdult: 24,
        employeeAssistanceApplyToAllSelected: data.employeeAssistanceApplyToAllSelected || false,
        terminationAge: typeof data.terminationAge === "number" ? data.terminationAge : 75,
        eligibilityPeriod: typeof data.eligibilityPeriod === "number" ? data.eligibilityPeriod : 3,
        minHoursPerWeek: typeof data.minHoursPerWeek === "number" ? data.minHoursPerWeek : 24,
        monthsSurvivorBenefit: typeof data.monthsSurvivorBenefit === "number" ? data.monthsSurvivorBenefit : 24,
        notes: data.notes || null,
        healthStopLoss: data.healthStopLoss || 0
      };
      if (defaults.paramedicalPerPractitionerSelected && !defaults.paramedicalSetPerPractitionerSelected && !defaults.paramedicalApplyAmountToAllSelected) {
        defaults.paramedicalApplyAmountToAllSelected = true;
        defaults.paramedicalSetPerPractitionerSelected = false;
      }
      if (defaults.paramedicalCombinedMaximumSelected && !defaults.paramedicalApplyAmountToAllSelected && !defaults.paramedicalCombineByGroupSelected) {
        defaults.paramedicalApplyAmountToAllSelected = true;
        defaults.paramedicalCombineByGroupSelected = false;
      }
      _this.setState({
        data: _objectSpread({}, defaults)
      });
      return defaults;
    }, _this._handleChange = function (field, value) {
      // we are viewing a revision so we don't need to set data in state
      if (_this.props.revision) {
        return;
      }
      _this.setState({
        data: _objectSpread(_objectSpread({}, _this.state.data), {}, (0, _defineProperty2["default"])({}, field, value))
      });
    }, _this._saveInGlobalState = function (field, value) {
      // we are viewing a revision so we don't need to set data in state
      if (_this.props.revision) {
        return;
      }
      if (field === 'notes' && value.toString().length === 0) {
        value = null;
      }
      if (_this.props.type === "modular") {
        _this.props.saveModularField(_this.props.classID, _this.props.tier, 'health', 'healthcare', field, value);
      } else {
        _this.props.savePlanDesignField(_this.props.selectedClassID, _this.props.selectedDesignID, 'healthcare', field, value);
      }
      _this.props.setChangesMadeFlag();
    }, _this._practitionerBlocks = function (data, errors) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].dropdowns.benefits.chiropractor),
        fullWidth: true,
        prefix: "$ ",
        value: data.paramedicalApplyAmountToAllSelected ? data.paramedicalMaximum : data.chiropractorMaximum,
        variant: "outlined",
        disabled: data.paramedicalApplyAmountToAllSelected,
        onChange: function onChange(e) {
          return _this._handleChange("chiropractorMaximum", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this._saveInGlobalState("chiropractorMaximum", e.target.value);
        },
        error: errors.chiropractorMaximum
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].dropdowns.benefits.registeredMassage),
        fullWidth: true,
        prefix: "$ ",
        value: data.paramedicalApplyAmountToAllSelected ? data.paramedicalMaximum : data.massageMaximum,
        variant: "outlined",
        disabled: data.paramedicalApplyAmountToAllSelected,
        onChange: function onChange(e) {
          return _this._handleChange("massageMaximum", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this._saveInGlobalState("massageMaximum", e.target.value);
        },
        error: errors.massageMaximum
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].dropdowns.benefits.naturopath),
        fullWidth: true,
        prefix: "$ ",
        value: data.paramedicalApplyAmountToAllSelected ? data.paramedicalMaximum : data.naturopathMaximum,
        variant: "outlined",
        disabled: data.paramedicalApplyAmountToAllSelected,
        onChange: function onChange(e) {
          return _this._handleChange("naturopathMaximum", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this._saveInGlobalState("naturopathMaximum", e.target.value);
        },
        error: errors.naturopathMaximum
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].dropdowns.benefits.osteopath),
        fullWidth: true,
        prefix: "$ ",
        value: data.paramedicalApplyAmountToAllSelected ? data.paramedicalMaximum : data.osteopathMaximum,
        variant: "outlined",
        disabled: data.paramedicalApplyAmountToAllSelected,
        onChange: function onChange(e) {
          return _this._handleChange("osteopathMaximum", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this._saveInGlobalState("osteopathMaximum", e.target.value);
        },
        error: errors.osteopathMaximum
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].dropdowns.benefits.occupationalTherapist),
        fullWidth: true,
        prefix: "$ ",
        value: data.paramedicalApplyAmountToAllSelected ? data.paramedicalMaximum : data.occupationalTherapistMaximum,
        variant: "outlined",
        disabled: data.paramedicalApplyAmountToAllSelected,
        onChange: function onChange(e) {
          return _this._handleChange("occupationalTherapistMaximum", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this._saveInGlobalState("occupationalTherapistMaximum", e.target.value);
        },
        error: errors.occupationalTherapistMaximum
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].dropdowns.benefits.physiotherapy),
        fullWidth: true,
        prefix: "$ ",
        value: data.paramedicalApplyAmountToAllSelected ? data.paramedicalMaximum : data.physiotherapyMaximum,
        variant: "outlined",
        disabled: data.paramedicalApplyAmountToAllSelected,
        onChange: function onChange(e) {
          return _this._handleChange("physiotherapyMaximum", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this._saveInGlobalState("physiotherapyMaximum", e.target.value);
        },
        error: errors.physiotherapyMaximum
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].dropdowns.benefits.podiatrist),
        fullWidth: true,
        prefix: "$ ",
        value: data.paramedicalApplyAmountToAllSelected ? data.paramedicalMaximum : data.podiatristMaximum,
        variant: "outlined",
        disabled: data.paramedicalApplyAmountToAllSelected,
        onChange: function onChange(e) {
          return _this._handleChange("podiatristMaximum", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this._saveInGlobalState("podiatristMaximum", e.target.value);
        },
        error: errors.podiatristMaximum
      })), !data.paramedicalGroupMentalWellnessSelected && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].dropdowns.benefits.psychologist),
        fullWidth: true,
        prefix: "$ ",
        value: data.paramedicalApplyAmountToAllSelected ? data.paramedicalMaximum : data.psychologistMaximum,
        variant: "outlined",
        disabled: data.paramedicalApplyAmountToAllSelected,
        onChange: function onChange(e) {
          return _this._handleChange("psychologistMaximum", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this._saveInGlobalState("psychologistMaximum", e.target.value);
        },
        error: errors.psychologistMaximum
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].dropdowns.benefits.speechTherapy),
        fullWidth: true,
        prefix: "$ ",
        value: data.paramedicalApplyAmountToAllSelected ? data.paramedicalMaximum : data.speechTherapyMaximum,
        variant: "outlined",
        disabled: data.paramedicalApplyAmountToAllSelected,
        onChange: function onChange(e) {
          return _this._handleChange("speechTherapyMaximum", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this._saveInGlobalState("speechTherapyMaximum", e.target.value);
        },
        error: errors.speechTherapyMaximum
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].dropdowns.benefits.acupuncturist),
        fullWidth: true,
        prefix: "$ ",
        value: data.paramedicalApplyAmountToAllSelected ? data.paramedicalMaximum : data.acupuncturistMaximum,
        variant: "outlined",
        disabled: data.paramedicalApplyAmountToAllSelected,
        onChange: function onChange(e) {
          return _this._handleChange("acupuncturistMaximum", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this._saveInGlobalState("acupuncturistMaximum", e.target.value);
        },
        error: errors.acupuncturistMaximum
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].dropdowns.benefits.chiropodist),
        fullWidth: true,
        prefix: "$ ",
        value: data.paramedicalApplyAmountToAllSelected ? data.paramedicalMaximum : data.chiropodistMaximum,
        variant: "outlined",
        disabled: data.paramedicalApplyAmountToAllSelected,
        onChange: function onChange(e) {
          return _this._handleChange("chiropodistMaximum", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this._saveInGlobalState("chiropodistMaximum", e.target.value);
        },
        error: errors.chiropodistMaximum
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].dropdowns.benefits.registeredDietician),
        fullWidth: true,
        prefix: "$ ",
        value: data.paramedicalApplyAmountToAllSelected ? data.paramedicalMaximum : data.registeredDieticianMaximum,
        variant: "outlined",
        disabled: data.paramedicalApplyAmountToAllSelected,
        onChange: function onChange(e) {
          return _this._handleChange("registeredDieticianMaximum", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this._saveInGlobalState("registeredDieticianMaximum", e.target.value);
        },
        error: errors.registeredDieticianMaximum
      })), !data.paramedicalGroupMentalWellnessSelected && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].dropdowns.benefits.socialWorker),
        fullWidth: true,
        prefix: "$ ",
        value: data.paramedicalApplyAmountToAllSelected ? data.paramedicalMaximum : data.socialWorkerMaximum,
        variant: "outlined",
        disabled: data.paramedicalApplyAmountToAllSelected,
        onChange: function onChange(e) {
          return _this._handleChange("socialWorkerMaximum", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this._saveInGlobalState("socialWorkerMaximum", e.target.value);
        },
        error: errors.socialWorkerMaximum
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].dropdowns.benefits.audiologist),
        fullWidth: true,
        prefix: "$ ",
        value: data.paramedicalApplyAmountToAllSelected ? data.paramedicalMaximum : data.audiologistMaximum,
        variant: "outlined",
        disabled: data.paramedicalApplyAmountToAllSelected,
        onChange: function onChange(e) {
          return _this._handleChange("audiologistMaximum", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this._saveInGlobalState("audiologistMaximum", e.target.value);
        },
        error: errors.audiologistMaximum
      }))));
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _createClass2["default"])(Healthcare, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // we are viewing a revision so we don't need to set data in state
      if (this.props.revision) {
        return;
      }
      var defaults = this._setData(this.props.data);
      if (this.props.type === "modular") {
        // save the init data in global state so it's there for the save
        this.props.saveModularBenefitInitData(this.props.classID, this.props.tier, 'health', 'healthcare', defaults);
        return;
      }

      // save the init data in global state so it's there for the save
      this.props.savePlanDesignBenefitInitData(this.props.selectedClassID, this.props.selectedDesignID, 'healthcare', defaults);
    }

    // eslint-disable-next-line camelcase
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var defaults = this._setData(nextProps.data);

      // we are viewing a revision so we don't need to set data in state
      if (this.props.revision) {
        return;
      }
      if (this.props.type === "modular") {
        return;
      }
      if (nextProps.selectedDesignID !== this.props.selectedDesignID) {
        // save the init data in global state so it's there for the save
        this.props.savePlanDesignBenefitInitData(this.props.selectedClassID, nextProps.selectedDesignID, 'healthcare', defaults);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      if (!this.state.data) {
        return null;
      }
      var _this$props = this.props,
        errors = _this$props.errors,
        whitelabel = _this$props.whitelabel,
        isMasterSite = _this$props.isMasterSite,
        revision = _this$props.revision,
        isRevisionBlock = _this$props.isRevisionBlock,
        lightTierColor = _this$props.lightTierColor,
        darkTierColor = _this$props.darkTierColor;
      var data = this.state.data;
      var isSelected = Boolean(data.isSelected);
      var tierLabelStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 90,
        padding: 5,
        marginRight: 10,
        backgroundColor: lightTierColor
      };
      return /*#__PURE__*/_react["default"].createElement(_BlockContent["default"], {
        style: isRevisionBlock ? {
          backgroundColor: '#F7F9FA'
        } : null
      }, /*#__PURE__*/_react["default"].createElement(_HeaderDiv["default"], {
        style: {
          borderBottom: isSelected ? "1.5px solid #F1F1F1" : null
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        large: true,
        bold: true,
        display: "block",
        margin: "20px 0",
        color: whitelabel.primaryColor || _theme.colors.skyBlue
      }, revision ? isRevisionBlock ? "".concat(_i18n["default"].t(_tokens["default"].titles.healthcare), " (").concat(revision.revisionID, ")") : _i18n["default"].t(_tokens["default"].labels.planDesign.healthcareCurrent) : _i18n["default"].t(_tokens["default"].titles.healthcare)), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'flex-end',
          flexDirection: 'row',
          flex: 1
        }
      }, this.props.tier && /*#__PURE__*/_react["default"].createElement("div", {
        style: tierLabelStyle
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        bold: true,
        medium: true,
        color: darkTierColor
      }, this.props.tier.toUpperCase())), /*#__PURE__*/_react["default"].createElement(_Switch["default"], {
        checked: data.isSelected,
        onChange: function onChange() {
          return _this2._saveInGlobalState("isSelected", !isSelected);
        }
      }))), data.isSelected && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          paddingTop: 20,
          paddingBottom: 50
        }
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.selectBetween)), /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        first: {
          title: _i18n["default"].t(_tokens["default"].labels.planDesign.deductible),
          selected: data.hasDeductible === true,
          field: 'hasDeductible'
        },
        second: {
          title: _i18n["default"].t(_tokens["default"].labels.planDesign.nonDeductible),
          selected: data.hasDeductible === false,
          field: 'hasDeductible'
        },
        handleChange: function handleChange() {
          return _this2._saveInGlobalState('hasDeductible', !data.hasDeductible);
        }
      }), data.hasDeductible && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.completeFollowing)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.advisor.solo),
        prefix: "$ ",
        fullWidth: true,
        value: data.soloDeductibleAmount,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("soloDeductibleAmount", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("soloDeductibleAmount", e.target.value);
        },
        error: errors.soloDeductibleAmount
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.advisor.duo),
        prefix: "$ ",
        fullWidth: true,
        value: data.duoDeductibleAmount,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("duoDeductibleAmount", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("duoDeductibleAmount", e.target.value);
        },
        error: errors.duoDeductibleAmount
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.advisor.family),
        prefix: "$ ",
        fullWidth: true,
        value: data.familyDeductibleAmount,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("familyDeductibleAmount", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("familyDeductibleAmount", e.target.value);
        },
        error: errors.familyDeductibleAmount
      })))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        mediumLarge: true,
        bold: true,
        display: "block",
        margin: "20px 0",
        color: whitelabel.primaryColor || _theme.colors.skyBlue
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.majorHealth)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.combineMajorHealth)), /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        first: {
          title: _i18n["default"].t(_tokens["default"].buttons.yes),
          selected: data.majorHealthCombinedMaximumSelected === true,
          field: 'majorHealthCombinedMaximumSelected'
        },
        second: {
          title: _i18n["default"].t(_tokens["default"].buttons.no),
          selected: data.majorHealthCombinedMaximumSelected === false,
          field: 'majorHealthCombinedMaximumSelected'
        },
        handleChange: function handleChange() {
          return _this2._saveInGlobalState('majorHealthCombinedMaximumSelected', !data.majorHealthCombinedMaximumSelected);
        }
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.completeFollowing)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.reimbursement),
        suffix: "%",
        fullWidth: true,
        value: data.majorHealthReimbursement,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("majorHealthReimbursement", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("majorHealthReimbursement", e.target.value);
        },
        error: errors.majorHealthReimbursement
      })), data.majorHealthCombinedMaximumSelected && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.combinedMajorHealthMaximum),
        prefix: "$ ",
        fullWidth: true,
        value: data.majorHealthCombinedMaximum,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("majorHealthCombinedMaximum", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("majorHealthCombinedMaximum", e.target.value);
        },
        error: errors.majorHealthCombinedMaximum
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].titles.stopLoss),
        prefix: "$ ",
        fullWidth: true,
        value: data.healthStopLoss,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("healthStopLoss", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("healthStopLoss", e.target.value);
        },
        error: errors.healthStopLoss
      }))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.footOrthotics),
        prefix: "$ ",
        fullWidth: true,
        value: data.footOrthotics,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("footOrthotics", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("footOrthotics", e.target.value);
        },
        error: errors.footOrthotics
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.orthopedicShoes),
        prefix: "$ ",
        fullWidth: true,
        value: data.orthopedicShoes,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("orthopedicShoes", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("orthopedicShoes", e.target.value);
        },
        error: errors.orthopedicShoes
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.coverage.hearingAids),
        prefix: "$ ",
        fullWidth: true,
        value: data.hearingAids,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("hearingAids", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("hearingAids", e.target.value);
        },
        error: errors.hearingAids
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.hearingAidsPeriodMonths),
        fullWidth: true,
        value: data.hearingAidsPeriod,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("hearingAidsPeriod", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("hearingAidsPeriod", e.target.value);
        },
        error: errors.hearingAidsPeriod
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.dentalAccidents),
        prefix: "$ ",
        fullWidth: true,
        value: data.dentalAccidentMax,
        variant: "outlined",
        error: errors.dentalAccidentMax,
        onChange: function onChange(e) {
          return _this2._handleChange("dentalAccidentMax", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("dentalAccidentMax", e.target.value);
        },
        disabled: !isMasterSite
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.dentalAccidentsReimbursement),
        fullWidth: true,
        suffix: "%",
        value: data.dentalAccidentReimbursement,
        onChange: function onChange(e) {
          return _this2._handleChange("dentalAccidentReimbursement", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("dentalAccidentReimbursement", e.target.value);
        },
        error: errors.dentalAccidentReimbursement,
        disabled: !isMasterSite,
        variant: "outlined"
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.glassesContactsCataractSurgery),
        prefix: "$ ",
        fullWidth: true,
        value: data.cataractSurgeryEyewear,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("cataractSurgeryEyewear", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("cataractSurgeryEyewear", e.target.value);
        },
        error: errors.cataractSurgeryEyewear
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.cataractSurgeryEyewearPeriodMonths),
        fullWidth: true,
        value: data.cataractSurgeryEyewearPeriod,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("cataractSurgeryEyewearPeriod", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("cataractSurgeryEyewearPeriod", e.target.value);
        },
        error: errors.cataractSurgeryEyewearPeriod
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.hospitalBenefitsType),
        fullWidth: true,
        value: localizationMaps.fromEnglish('hospitalBenefitsType', data.hospitalBenefitsType),
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("hospitalBenefitsType", localizationMaps.toEnglish('hospitalBenefitsType', e.target.value));
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("hospitalBenefitsType", localizationMaps.toEnglish('hospitalBenefitsType', e.target.value));
        },
        error: errors.hospitalBenefitsType,
        select: true,
        selectOptions: _services.selectFieldOptions.hospitalBenefitsType()
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.hospitalBenefitsReimbursement),
        suffix: "%",
        fullWidth: true,
        value: data.hospitalBenefitsReimbursement,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("hospitalBenefitsReimbursement", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("hospitalBenefitsReimbursement", e.target.value);
        },
        error: errors.hospitalBenefitsReimbursement
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.privateDutyNursing),
        prefix: "$ ",
        fullWidth: true,
        value: data.privateDutyNursing,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("privateDutyNursing", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("privateDutyNursing", e.target.value);
        },
        error: errors.privateDutyNursing,
        disabled: !isMasterSite
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.prosthetics),
        prefix: "$ ",
        fullWidth: true,
        value: data.prosthetics,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("prosthetics", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("prosthetics", e.target.value);
        },
        error: errors.prosthetics,
        disabled: !isMasterSite
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.cardiacRehabilitation),
        prefix: "$ ",
        fullWidth: true,
        value: data.cardiacRehabilitation,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("cardiacRehabilitation", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("cardiacRehabilitation", e.target.value);
        },
        error: errors.cardiacRehabilitation,
        disabled: !isMasterSite
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.apneaMachineCPAP),
        prefix: "$ ",
        fullWidth: true,
        value: data.apneaMachine,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("apneaMachine", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("apneaMachine", e.target.value);
        },
        error: errors.apneaMachine,
        disabled: !isMasterSite
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.artificialEyeLimbRepairReplacement),
        prefix: "$ ",
        fullWidth: true,
        value: data.artificialEyeLimbRepairReplacement,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("artificialEyeLimbRepairReplacement", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("artificialEyeLimbRepairReplacement", e.target.value);
        },
        error: errors.artificialEyeLimbRepairReplacement,
        disabled: !isMasterSite
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.bloodPressureMonitor),
        prefix: "$ ",
        fullWidth: true,
        value: data.bloodPressureMonitor,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("bloodPressureMonitor", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("bloodPressureMonitor", e.target.value);
        },
        error: errors.bloodPressureMonitor,
        disabled: !isMasterSite
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.compressionStockings),
        prefix: "$ ",
        fullWidth: true,
        value: data.compressionStockings,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("compressionStockings", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("compressionStockings", e.target.value);
        },
        error: errors.compressionStockings,
        disabled: !isMasterSite
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.glucoseMonitoringEquipmentSupplies),
        prefix: "$ ",
        fullWidth: true,
        value: data.glucoseMonitoringEquipmentSupplies,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("glucoseMonitoringEquipmentSupplies", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("glucoseMonitoringEquipmentSupplies", e.target.value);
        },
        error: errors.glucoseMonitoringEquipmentSupplies,
        disabled: !isMasterSite
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.insulinPump),
        prefix: "$ ",
        fullWidth: true,
        value: data.insulinPump,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("insulinPump", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("insulinPump", e.target.value);
        },
        error: errors.insulinPump,
        disabled: !isMasterSite
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.insulinPumpSupplies),
        prefix: "$ ",
        fullWidth: true,
        value: data.insulinPumpSupplies,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("insulinPumpSupplies", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("insulinPumpSupplies", e.target.value);
        },
        error: errors.insulinPumpSupplies,
        disabled: !isMasterSite
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.tensMachine),
        prefix: "$ ",
        fullWidth: true,
        value: data.tensMachine,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("tensMachine", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("tensMachine", e.target.value);
        },
        error: errors.tensMachine,
        disabled: !isMasterSite
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.viscosupplementation),
        prefix: "$ ",
        fullWidth: true,
        value: data.viscosupplementation,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("viscosupplementation", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("viscosupplementation", e.target.value);
        },
        error: errors.viscosupplementation,
        disabled: !isMasterSite
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.wheelchairManual),
        prefix: "$ ",
        fullWidth: true,
        value: data.wheelchairManual,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("wheelchairManual", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("wheelchairManual", e.target.value);
        },
        error: errors.wheelchairManual,
        disabled: !isMasterSite
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.wheelchairElectric),
        prefix: "$ ",
        fullWidth: true,
        value: data.wheelchairElectric,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("wheelchairElectric", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("wheelchairElectric", e.target.value);
        },
        error: errors.wheelchairElectric,
        disabled: !isMasterSite
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.wigs),
        prefix: "$ ",
        fullWidth: true,
        value: data.wigs,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("wigs", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("wigs", e.target.value);
        },
        error: errors.wigs,
        disabled: !isMasterSite
      }))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.includeConvalescentHospital),
        isSelected: data.includeConvalescentHospital,
        onClick: function onClick() {
          return _this2._saveInGlobalState("includeConvalescentHospital", !data.includeConvalescentHospital);
        }
      }))), data.includeConvalescentHospital && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.convalescentHospitalReimbursement),
        suffix: "%",
        fullWidth: true,
        value: data.convalescentHospitalReimbursement,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("convalescentHospitalReimbursement", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("convalescentHospitalReimbursement", e.target.value);
        },
        error: errors.convalescentHospitalReimbursement
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.convalescentHospitalDailyMaximum),
        fullWidth: true,
        value: data.convalescentHospitalDailyMax,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("convalescentHospitalDailyMax", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("convalescentHospitalDailyMax", e.target.value);
        },
        error: errors.convalescentHospitalDailyMax,
        select: true,
        selectOptions: [{
          key: '20',
          value: '20'
        }, {
          key: '25',
          value: '25'
        }, {
          key: '40',
          value: '40'
        }, {
          key: '60',
          value: '60'
        }]
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.convalescentHospitalMaximumDays),
        fullWidth: true,
        value: data.convalescentHospitalMaxDays,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("convalescentHospitalMaxDays", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("convalescentHospitalMaxDays", e.target.value);
        },
        error: errors.convalescentHospitalMaxDays,
        select: true,
        selectOptions: [{
          key: '90',
          value: '90'
        }, {
          key: '120',
          value: '120'
        }, {
          key: '180',
          value: '180'
        }]
      }))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.includeDiagnosticServices),
        isSelected: data.includeDiagnosticServices,
        onClick: function onClick() {
          return _this2._saveInGlobalState("includeDiagnosticServices", !data.includeDiagnosticServices);
        }
      }))), data.includeDiagnosticServices && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.diagnosticServicesReimbursement),
        value: data.diagnosticServicesReimbursement,
        fullWidth: true,
        variant: "outlined",
        suffix: "%",
        onChange: function onChange(e) {
          return _this2._handleChange("diagnosticServicesReimbursement", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("diagnosticServicesReimbursement", e.target.value);
        },
        error: errors.diagnosticServicesReimbursement
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.diagnosticServicesMaximum),
        value: data.diagnosticServicesMax,
        fullWidth: true,
        variant: "outlined",
        prefix: "$ ",
        onChange: function onChange(e) {
          return _this2._handleChange("diagnosticServicesMax", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("diagnosticServicesMax", e.target.value);
        },
        error: errors.diagnosticServicesMax
      }))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.includeMedicalReferral),
        isSelected: data.includeMedicalReferral,
        onClick: function onClick() {
          return _this2._saveInGlobalState("includeMedicalReferral", !data.includeMedicalReferral);
        }
      }))), data.includeMedicalReferral && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.medicalReferralReimbursement),
        value: data.medicalReferralReimbursement,
        fullWidth: true,
        variant: "outlined",
        suffix: "%",
        onChange: function onChange(e) {
          return _this2._handleChange("medicalReferralReimbursement", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("medicalReferralReimbursement", e.target.value);
        },
        error: errors.medicalReferralReimbursement
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 12,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.medicalReferralMaximum),
        value: data.medicalReferralMax,
        fullWidth: true,
        variant: "outlined",
        prefix: "$ ",
        onChange: function onChange(e) {
          return _this2._handleChange("medicalReferralMax", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("medicalReferralMax", e.target.value);
        },
        error: errors.medicalReferralMax
      }))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        mediumLarge: true,
        bold: true,
        display: "block",
        margin: "20px 0",
        color: whitelabel.primaryColor || _theme.colors.skyBlue
      }, _i18n["default"].t(_tokens["default"].titles.paramedical)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.completeFollowing)), /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        first: {
          title: _i18n["default"].t(_tokens["default"].labels.planDesign.perPractitioner),
          selected: data.paramedicalPerPractitionerSelected,
          field: 'paramedicalPerPractitionerSelected'
        },
        second: {
          title: _i18n["default"].t(_tokens["default"].labels.planDesign.combinedMaximum),
          selected: data.paramedicalCombinedMaximumSelected,
          field: 'paramedicalCombinedMaximumSelected'
        },
        third: {
          title: _i18n["default"].t(_tokens["default"].labels.planDesign.both),
          selected: data.paramedicalPerPractitionerToCombinedMaximumSelected,
          field: 'paramedicalPerPractitionerToCombinedMaximumSelected'
        },
        handleChange: function handleChange(field, value) {
          return _this2._saveInGlobalState(field, value);
        }
      }), data.paramedicalPerPractitionerToCombinedMaximumSelected ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.paramedicalReimbursement),
        fullWidth: true,
        suffix: "%",
        value: data.paramedicalReimbursement,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("paramedicalReimbursement", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("paramedicalReimbursement", e.target.value);
        },
        error: errors.paramedicalReimbursement
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.combinedParamedicalMaximum),
        fullWidth: true,
        prefix: "$ ",
        value: data.paramedicalCombinedMaximum,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("paramedicalCombinedMaximum", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("paramedicalCombinedMaximum", e.target.value);
        },
        error: errors.paramedicalCombinedMaximum
      }))), /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        first: {
          title: _i18n["default"].t(_tokens["default"].labels.planDesign.applyAmountToAll),
          selected: data.paramedicalApplyAmountToAllSelected,
          field: 'paramedicalApplyAmountToAllSelected'
        },
        second: {
          title: _i18n["default"].t(_tokens["default"].labels.planDesign.setPerPractitioner),
          selected: data.paramedicalSetPerPractitionerSelected,
          field: 'paramedicalSetPerPractitionerSelected'
        },
        handleChange: function handleChange(field, value) {
          return _this2._saveInGlobalState(field, value);
        }
      }), data.paramedicalApplyAmountToAllSelected && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.paramedicalMaximum),
        fullWidth: true,
        prefix: "$ ",
        value: data.paramedicalMaximum,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("paramedicalMaximum", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("paramedicalMaximum", e.target.value);
        },
        error: errors.paramedicalMaximum
      }))), this._practitionerBlocks(data, errors)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        first: {
          title: _i18n["default"].t(_tokens["default"].labels.planDesign.applyAmountToAll),
          selected: data.paramedicalApplyAmountToAllSelected,
          field: 'paramedicalApplyAmountToAllSelected'
        },
        second: {
          title: data.paramedicalPerPractitionerSelected ? _i18n["default"].t(_tokens["default"].labels.planDesign.setPerPractitioner) : _i18n["default"].t(_tokens["default"].labels.planDesign.combineByGroup),
          selected: data.paramedicalPerPractitionerSelected ? data.paramedicalSetPerPractitionerSelected : data.paramedicalCombineByGroupSelected,
          field: data.paramedicalPerPractitionerSelected ? 'paramedicalSetPerPractitionerSelected' : 'paramedicalCombineByGroupSelected'
        },
        handleChange: function handleChange(field, value) {
          return _this2._saveInGlobalState(field, value);
        }
      }), data.paramedicalCombinedMaximumSelected && data.paramedicalApplyAmountToAllSelected && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.completeFollowing)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.paramedicalReimbursement),
        fullWidth: true,
        suffix: "%",
        value: data.paramedicalReimbursement,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("paramedicalReimbursement", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("paramedicalReimbursement", e.target.value);
        },
        error: errors.paramedicalReimbursement
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.combinedParamedicalMaximum),
        fullWidth: true,
        prefix: "$ ",
        value: data.paramedicalCombinedMaximum,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("paramedicalCombinedMaximum", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("paramedicalCombinedMaximum", e.target.value);
        },
        error: errors.paramedicalCombinedMaximum
      }))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.divideAmongProviders))), data.paramedicalCombinedMaximumSelected && data.paramedicalCombineByGroupSelected && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.completeFollowing)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.paramedicalReimbursement),
        fullWidth: true,
        suffix: "%",
        value: data.paramedicalReimbursement,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("paramedicalReimbursement", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("paramedicalReimbursement", e.target.value);
        },
        error: errors.paramedicalReimbursement
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.combinedParamedicalMaximum),
        fullWidth: true,
        prefix: "$ ",
        value: data.paramedicalCombinedMaximum,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("paramedicalCombinedMaximum", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("paramedicalCombinedMaximum", e.target.value);
        },
        error: errors.paramedicalCombinedMaximum
      }))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.divideAmongProviders)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.mentalWellnessReimbursement),
        fullWidth: true,
        suffix: "%",
        value: data.mentalWellnessReimbursement,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("mentalWellnessReimbursement", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("mentalWellnessReimbursement", e.target.value);
        },
        error: errors.mentalWellnessReimbursement
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.mentalWellnessMaximum),
        fullWidth: true,
        prefix: "$ ",
        value: data.mentalWellnessMaximum,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("mentalWellnessMaximum", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("mentalWellnessMaximum", e.target.value);
        },
        error: errors.mentalWellnessMaximum
      }))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.divideAmountAmongPsychologistSocialWorker))), data.paramedicalPerPractitionerSelected && (data.paramedicalApplyAmountToAllSelected || data.paramedicalSetPerPractitionerSelected) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.completeFollowing)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.paramedicalReimbursement),
        fullWidth: true,
        suffix: "%",
        value: data.paramedicalReimbursement,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("paramedicalReimbursement", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("paramedicalReimbursement", e.target.value);
        },
        error: errors.paramedicalReimbursement
      })), data.paramedicalApplyAmountToAllSelected && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.paramedicalMaximum),
        fullWidth: true,
        prefix: "$ ",
        value: data.paramedicalMaximum,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("paramedicalMaximum", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("paramedicalMaximum", e.target.value);
        },
        error: errors.paramedicalMaximum
      }))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.groupMentalWellnessServices)), /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        first: {
          title: _i18n["default"].t(_tokens["default"].buttons.yes),
          selected: data.paramedicalGroupMentalWellnessSelected === true,
          field: 'paramedicalGroupMentalWellnessSelectedYes'
        },
        second: {
          title: _i18n["default"].t(_tokens["default"].buttons.no),
          selected: data.paramedicalGroupMentalWellnessSelected === false,
          field: 'paramedicalGroupMentalWellnessSelectedNo'
        },
        handleChange: function handleChange(field) {
          return _this2._saveInGlobalState("paramedicalGroupMentalWellnessSelected", field === 'paramedicalGroupMentalWellnessSelectedYes');
        }
      }), data.paramedicalGroupMentalWellnessSelected && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.mentalWellnessReimbursement),
        fullWidth: true,
        suffix: "%",
        value: data.mentalWellnessReimbursement,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("mentalWellnessReimbursement", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("mentalWellnessReimbursement", e.target.value);
        },
        error: errors.mentalWellnessReimbursement
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.mentalWellnessMaximum),
        fullWidth: true,
        prefix: "$ ",
        value: data.mentalWellnessMaximum,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("mentalWellnessMaximum", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("mentalWellnessMaximum", e.target.value);
        },
        error: errors.mentalWellnessMaximum
      }))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.divideAmountAmongPsychologistSocialWorker))), this._practitionerBlocks(data, errors))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        mediumLarge: true,
        bold: true,
        display: "block",
        margin: "20px 0",
        color: whitelabel.primaryColor || _theme.colors.skyBlue
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.visionCare)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.selectBetween)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.eyeExams),
        isSelected: data.includeEyeExams,
        onClick: function onClick() {
          return _this2._saveInGlobalState("includeEyeExams", !data.includeEyeExams);
        }
      }))), data.includeEyeExams && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.reimbursement),
        fullWidth: true,
        suffix: "%",
        value: data.eyeExamReimbursement,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("eyeExamReimbursement", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("eyeExamReimbursement", e.target.value);
        },
        error: errors.eyeExamReimbursement
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.twelveMonthChildMaximum),
        fullWidth: true,
        prefix: "$ ",
        value: data.eyeExamChildMax,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("eyeExamChildMax", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("eyeExamChildMax", e.target.value);
        },
        error: errors.eyeExamChildMax
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.twentyFourMonthAdultMaximum),
        fullWidth: true,
        prefix: "$ ",
        value: data.eyeExamAdultMax,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("eyeExamAdultMax", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("eyeExamAdultMax", e.target.value);
        },
        error: errors.eyeExamAdultMax
      }))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.eyeGlassesContactLenses),
        isSelected: data.includeEyeGlassesAndContacts,
        onClick: function onClick() {
          return _this2._saveInGlobalState("includeEyeGlassesAndContacts", !data.includeEyeGlassesAndContacts);
        }
      }))), data.includeEyeGlassesAndContacts && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.reimbursement),
        fullWidth: true,
        suffix: "%",
        value: data.eyeGlassesAndContactsReimbursement,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("eyeGlassesAndContactsReimbursement", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("eyeGlassesAndContactsReimbursement", e.target.value);
        },
        error: errors.eyeGlassesAndContactsReimbursement
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.twelveMonthChildMaximum),
        fullWidth: true,
        prefix: "$ ",
        value: data.eyeGlassesAndContactsChildMax,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("eyeGlassesAndContactsChildMax", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("eyeGlassesAndContactsChildMax", e.target.value);
        },
        error: errors.eyeGlassesAndContactsChildMax
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.twentyFourMonthAdultMaximum),
        fullWidth: true,
        prefix: "$ ",
        value: data.eyeGlassesAndContactsAdultMax,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("eyeGlassesAndContactsAdultMax", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("eyeGlassesAndContactsAdultMax", e.target.value);
        },
        error: errors.eyeGlassesAndContactsAdultMax
      }))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.medicallyRequiredContactLenses),
        isSelected: data.includeRequiredSafetyEyeWear,
        onClick: function onClick() {
          return _this2._saveInGlobalState("includeRequiredSafetyEyeWear", !data.includeRequiredSafetyEyeWear);
        }
      }))), data.includeRequiredSafetyEyeWear && /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.reimbursement),
        fullWidth: true,
        suffix: "%",
        value: data.requiredSafetyEyeWearReimbursement,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("requiredSafetyEyeWearReimbursement", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("requiredSafetyEyeWearReimbursement", e.target.value);
        },
        error: errors.requiredSafetyEyeWearReimbursement
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.twelveMonthChildMaximum),
        fullWidth: true,
        prefix: "$ ",
        value: data.requiredSafetyEyeWearChildMax,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("requiredSafetyEyeWearChildMax", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("requiredSafetyEyeWearChildMax", e.target.value);
        },
        error: errors.requiredSafetyEyeWearChildMax
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.twentyFourMonthAdultMaximum),
        fullWidth: true,
        prefix: "$ ",
        value: data.requiredSafetyEyeWearAdultMax,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("requiredSafetyEyeWearAdultMax", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("requiredSafetyEyeWearAdultMax", e.target.value);
        },
        error: errors.requiredSafetyEyeWearAdultMax
      }))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        mediumLarge: true,
        bold: true,
        margin: "20px 0 10px 0"
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.planEligibilityTermination)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.completeFollowing)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        container: true,
        direction: "row",
        alignItems: "center",
        spacing: 2
      }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.eligibilityPeriodMonths),
        fullWidth: true,
        value: data.eligibilityPeriod,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("eligibilityPeriod", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("eligibilityPeriod", e.target.value);
        },
        error: errors.eligibilityPeriod
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.minimumHoursPerWeek),
        fullWidth: true,
        value: data.minHoursPerWeek,
        variant: "outlined",
        onChange: function onChange(e) {
          return _this2._handleChange("minHoursPerWeek", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("minHoursPerWeek", e.target.value);
        },
        error: errors.minHoursPerWeek
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.terminationAge),
        fullWidth: true,
        value: data.terminationAge,
        onChange: function onChange(e) {
          return _this2._handleChange("terminationAge", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("terminationAge", e.target.value);
        },
        error: errors.terminationAge,
        variant: "outlined"
      })), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
        item: true,
        xs: 6,
        sm: 4
      }, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.planDesign.survivorBenefitsMonths),
        fullWidth: true,
        value: data.monthsSurvivorBenefit,
        onChange: function onChange(e) {
          return _this2._handleChange("monthsSurvivorBenefit", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("monthsSurvivorBenefit", e.target.value);
        },
        error: errors.monthsSurvivorBenefit,
        variant: "outlined"
      }))), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        bold: true
      }, "Notes:"), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        fullWidth: true,
        value: data.notes || '',
        variant: "outlined",
        error: errors.notes,
        onChange: function onChange(e) {
          return _this2._handleChange("notes", e.target.value);
        },
        onBlur: function onBlur(e) {
          return _this2._saveInGlobalState("notes", e.target.value);
        },
        multiline: true,
        rows: 5,
        placeholder: _i18n["default"].t(_tokens["default"].labels.planDesign.additionalRequestsInformation)
      })));
    }
  }]);
  return Healthcare;
}(_react.Component);
var _default = exports["default"] = Healthcare;